export default "__VITE_ASSET__CV6qNwbH__"